import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Checkbox,
  Tooltip,
  Modal,
  Spin,
  message,
  Avatar,
} from "antd";
import {
  CheckCircleFilled,
  DeleteOutlined,
  EyeOutlined,
  SearchOutlined,
  UserOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { LuArrowUpDown } from "react-icons/lu";
import VarifyRequest from "./VarifyRequest";
import { MdBlockFlipped, MdWarning } from "react-icons/md";
import * as XLSX from "xlsx";
import "./Indivisual.css";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../../common/Pagination";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { getAllBuyer, updateBuyerStatus } from "../../../api/AdminRequest";
import { Link, useNavigate } from "react-router-dom";


const BuyerList = () => {

  const navigate = useNavigate();
  const [showVerifyRequest, setShowVerifyRequest] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const showModal = (buyer) => {
    setSelectedContact(buyer);
    setIsModalVisible(true);
  };

  const [loader, setLoader] = useState(false);

  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);

  const [activeTab, setActiveTab] = useState(""); // Update initial state to 'all'
  const [tabFilter, setTabFilter] = useState(""); // Update initial state to 'all'
  const [buyerList, setBuyerList] = useState([]); // Update initial state to '
  const [verifyCount, setVerifyCount] = useState(0);

  const [selectedUsers, setSelectedUsers] = useState([]);
  const tabs = [
    { label: "All", value: "" },
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
    { label: "Blacklisted", value: "deactive" },
  ];

  const handleSelectUser = (user) => {
    setSelectedUsers((prevSelectedUsers) => {
      const isSelected = prevSelectedUsers.some(
        (selectedUser) => selectedUser._id === user._id
      );
      if (isSelected) {
        return prevSelectedUsers.filter(
          (selectedUser) => selectedUser._id !== user._id
        );
      } else {
        return [...prevSelectedUsers, user];
      }
    });
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  useEffect(() => {
    const buyerCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAllBuyer({
          page: currentPage,
          limit: limit,
          status: tabFilter,
        });

        if (data?.success) {
          // console.log(data, "data in user");

          setBuyerList(data?.buyerList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setVerifyCount(
            data?.verifyRequestCount ? data?.verifyRequestCount : 0
          );
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);

        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    buyerCall();
  }, [limit, currentPage, tabFilter, trigger]);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };


  if (showVerifyRequest) {
    return <VarifyRequest />;
  }
  const handleDownloadData = () => {
    if (selectedUsers.length === 0) {
      message.warning("Please select at least one user to download.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(
      selectedUsers.map((user) => ({
        Name: user.name,
        Email: user.email,
        "Company Email": user.companyEmail,
        "Created Date": new Date(user.createdDate).toLocaleDateString(),
        "Wallet Balance": user.walletBalance,
        Status: user.status,
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    XLSX.writeFile(workbook, "selected_users.xlsx");

    message.success(
      `Data for ${selectedUsers.length} user(s) downloaded successfully.`
    );
  };

  const handleCancelSelection = () => {
    setSelectedUsers([]);
    message.info("Selection cancelled.");
  };

  // ----------------------- DELETE Conform ----------------
  const showUpdateConfirm = (id, action) => {
    Modal.confirm({
      title: "Confirm Status Update",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to ${action} this user?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return handleUpdateUserStatus(id, action);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  // ------------- BLOCK WARNING ----------------
  const showBlockConfirm = (id, currentStatus) => {
    let nextAction;
    let actionText;

    switch (currentStatus) {
      case "active":
        nextAction = "warn1";
        actionText = "give the first warning to";
        break;
      case "warn1":
        nextAction = "warn2";
        actionText = "give the second warning to";
        break;
      case "warn2":
        nextAction = "deactive";
        actionText = "deactive";
        break;
      case "deactive":
        nextAction = "active";
        actionText = "active";
        break;
      default:
        nextAction = "warn1";
        actionText = "give the first warning to";
    }

    Modal.confirm({
      title: "Confirm Action",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to ${actionText} this user?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return handleUpdateUserStatus(id, nextAction);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleUpdateUserStatus = async (id, action) => {
    try {
      const { data } = await updateBuyerStatus(id, action);

      if (data.success) {
        message.success("User status updated successfully");
        setTrigger(!trigger);

        // Refresh the user list or update the local state
      } else {
        message.error("Failed to update user status");
        setTrigger(!trigger);

      }
      setTrigger(!trigger);
    } catch (error) {
      console.log("Error updating user status:", error);
      message.error("An error occurred while updating user status");
    }
  };

  const handleSingleView = (id) => {
    navigate("/buyer-single-view", { state: id })

  };



  const columns = [
    {
      title: "Select",
      dataIndex: "select",
      width: 60,
      render: (_, record) => (
        <Checkbox
          checked={selectedUsers.some((user) => user._id === record._id)}
          onChange={() => handleSelectUser(record)}
        />
      ),
    },

    {
      title: (
        <div className="flex items-center gap-2">
          Buyer Name
        </div>
      ),
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div className="flex items-center">
          <Avatar
            src={record.idImage1}
            icon={<UserOutlined />}
            className="mr-2"
          />
          <span className="text-[#313131] text-[12px] font-medium">{text}</span>
          {record.roleDetails?.idVerification === "completed" && (
            <Tooltip title="Verified">
              <CheckCircleFilled className="text-blue-500 ml-2" />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Email
        </div>
      ),
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <span className="text-[#313131] text-[12px] font-medium">{text}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Phone
        </div>
      ),
      dataIndex: "phone",
      key: "phone",
      render: (text) => (
        <span className="text-[#313131] text-[12px] font-medium">{text}</span>
      ),
    },
    {
      title: (
        <div className="flex items-center gap-2">
          Joined Date
          <LuArrowUpDown className="text-[#9FACF0]" />
        </div>
      ),
      dataIndex: "createdDate",
      key: "createdAt",
      render: (date) => moment(date).format("DD MMM YYYY"),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <div className="flex items-center gap-2">
          <span
            className={`py-1 rounded-full text-xs ${status === "deactive"
              ? "text-red-600"
              : status === "delete"
                ? "text-gray-600"
                : "text-green-600"
              }`}
          >
            {status === "deactive"
              ? "Deactivate"
              : status === "delete"
                ? "Deleted"
                : "Active"}
          </span>
          {status === "warn1" && (
            <Tooltip title="First Warning">
              <MdWarning className="text-yellow-600 ml-2" />
            </Tooltip>
          )}
          {status === "warn2" && (
            <>
              <Tooltip title="First Warning">
                <MdWarning className="text-yellow-600 ml-2" />
              </Tooltip>
              <Tooltip title="Second Warning">
                <MdWarning className="text-orange-600 ml-2" />
              </Tooltip>
            </>
          )}
        </div>
      ),
    },
    {
      title: "ID Verification Status",
      dataIndex: "roleDetails",
      key: "roleDetails",
      render: (roleDetails) => (
        <div className="flex items-center gap-2">
          <span
            className={`py-1 rounded-full text-xs ${roleDetails.idVerification === "pending"
              ? "text-yellow-600"
              : roleDetails.idVerification === "requested"
                ? "text-blue-600"
                : roleDetails.idVerification === "rejected" ? "text-red-600"
                  : "text-green-600"
              }`}
          >
            {roleDetails.idVerification === "pending"
              ? "Pending"
              : roleDetails.idVerification === "requested"
                ? "Requested"
                : roleDetails.idVerification === "rejected" ? "Rejected"
                  : "Completed"}
          </span>

        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <Tooltip title="View Details">
            <button
              onClick={() => handleSingleView(record._id)}
              className="w-8 h-8 flex items-center justify-center bg-blue-50 text-[#1955EB] rounded-lg hover:bg-[#1955EB] hover:text-white transition-all shadow-sm border border-blue-100"
            >
              <EyeOutlined style={{ fontSize: 16 }} />
            </button>
          </Tooltip>

          {record.status !== "delete" && (
            <>
              <Tooltip title={record.status === "deactive" ? "Activate User" : "Block / Warn"}>
                <button
                  onClick={() => showBlockConfirm(record._id, record.status)}
                  className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all shadow-sm border ${record.status === "deactive"
                    ? "bg-green-50 text-green-600 border-green-100 hover:bg-green-600 hover:text-white"
                    : "bg-orange-50 text-orange-600 border-orange-100 hover:bg-orange-600 hover:text-white"
                    }`}
                >
                  <MdBlockFlipped size={16} />
                </button>
              </Tooltip>

              <Tooltip title="Delete User">
                <button
                  onClick={() => showUpdateConfirm(record._id, "delete")}
                  className="w-8 h-8 flex items-center justify-center bg-red-50 text-red-600 rounded-lg hover:bg-red-600 hover:text-white transition-all shadow-sm border border-red-100"
                >
                  <DeleteOutlined style={{ fontSize: 16 }} />
                </button>
              </Tooltip>
            </>
          )}
        </div>
      ),
    },
  ];

  return (

    <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
      <div className="">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6 mt-2">
          <div className="w-full lg:w-auto overflow-x-auto scrollbar-hide py-1">
            <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                      ${activeTab === tab.value
                      ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                      : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                    }`}
                  onClick={() => {
                    setActiveTab(tab.value);
                    setTabFilter(tab.value);
                    setCurrentPage(1);
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center border border-[#9FACF0] p-1 rounded-lg bg-white shadow-sm w-full md:w-auto">
            <div className="px-3 flex items-center gap-2 py-1">
              <span className="text-sm font-semibold text-gray-700">Verify Requests</span>
              <span className="text-[#1955EB] font-bold">{verifyCount}</span>
            </div>
            <Link to='/buyer-verify-request' className="ml-2">
              <button className="bg-[#1955EB] text-white font-bold h-10 px-6 text-sm rounded-lg hover:bg-blue-700 transition-all shadow-md active:scale-95">
                Open
              </button>
            </Link>
          </div>
        </div>
        <Spin spinning={loader}>
          <div className="pt-[0px] space-y-10 ">
            <Table
              columns={columns}
              dataSource={buyerList}
              pagination={false}
              className="custom-table-header w-full overflow-x-auto custom-pagination border border-gray-100 rounded-xl"
            />
            <div className="">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                limit={limit}
                totalItem={totalItems}
                onPageChange={handlePageChange}
                handleLimit={handleLimit}
              />
            </div>
          </div>
        </Spin>
        <Modal
          title={
            <h2 className="text-[24px] text-[#000000] font-medium border-b-2 pb-2">
              Contact Info
            </h2>
          }
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <div className="flex justify-center">
              <Button
                className="flex justify-center bg-[#313131] h-10 w-fit text-[16px] text-[#FFFFFF]"
                key="dismiss"
                onClick={handleCancel}
              >
                Dismiss
              </Button>
            </div>,
          ]}
        >
          {selectedContact && (
            <div className="space-y-3">
              <div className="flex justify-between">
                <p className="text-[16px] text-[#313131] font-semibold">
                  Name:
                </p>
                <p className="text-[#4A4A4C] text-[16px] font-normal">
                  {selectedContact.name}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-[16px] text-[#313131] font-semibold">
                  Email:
                </p>
                <p className="text-[#4A4A4C] text-[16px] font-normal">
                  {selectedContact.email}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-[16px] text-[#313131] font-semibold">
                  Company Email:
                </p>
                <p className="text-[#4A4A4C] text-[16px] font-normal">
                  {selectedContact.companyEmail}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-[16px] text-[#313131] font-semibold">
                  Phone:
                </p>
                <p className="text-[#4A4A4C] text-[16px] font-normal">
                  {selectedContact.phone || "N/A"}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-[16px] text-[#313131] font-semibold">
                  Address:
                </p>
                <div className="text-[#4A4A4C] text-[16px] font-normal">
                  <p>{selectedContact.address?.line1 || "N/A"}</p>
                  <p>{selectedContact.address?.line2 || ""}</p>
                  <p>{selectedContact.address?.line3 || ""}</p>
                </div>
              </div>
              <div className="flex justify-between">
                <p className="text-[16px] text-[#313131] font-semibold">
                  Status:
                </p>
                <p className="text-[#4A4A4C] text-[16px] font-normal">
                  {selectedContact.status}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="text-[16px] text-[#313131] font-semibold">
                  Created At:
                </p>
                <p className="text-[#4A4A4C] text-[16px] font-normal">
                  {new Date(selectedContact.createdDate).toLocaleDateString(
                    "en-US",
                    {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </p>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default BuyerList;
